var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(-281 -203.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5016",
    "data-name": "Path 5016",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    transform: "translate(281 203.5)",
    fill: "#00286F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user(3)",
    transform: "translate(297 215.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5004",
    "data-name": "Path 5004",
    d: "M12.265,12.53A6.265,6.265,0,1,0,6,6.265a6.265,6.265,0,0,0,6.265,6.265Zm0-10.442A4.177,4.177,0,1,1,8.088,6.265a4.177,4.177,0,0,1,4.177-4.177Z",
    transform: "translate(-2.868 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5005",
    "data-name": "Path 5005",
    d: "M12.4,14A9.408,9.408,0,0,0,3,23.4a1.044,1.044,0,0,0,2.088,0,7.309,7.309,0,1,1,14.618,0,1.044,1.044,0,0,0,2.088,0A9.408,9.408,0,0,0,12.4,14Z",
    transform: "translate(-3 0.618)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserslogo);
export default __webpack_public_path__ + "static/media/userslogo.eb1e155fc71ef81f373c023117c88cb2.svg";
export { ForwardRef as ReactComponent };